import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import _ from 'lodash-es';

@Injectable()
export class ScraperProgressService {
  constructor(private http: HttpClient) {}

  public getScraperProgress(studyId: number): Observable<any> {
    return this.http.get<any>('/api/InternetReview/GetScraperProgress?studyId=' + studyId);
  }

  public hasPageTitlesRetrievalEnded(searchStrategyId: number, comparableIds: Array<number>): Observable<any> {
    const ids = _.join(comparableIds, '&ids=');
    return this.http.get<any>('/api/InternetReview/HasPageTitlesRetrievalEnded?searchStrategyId=' + searchStrategyId + '&ids=' + ids);
  }

  public downloadScreenshot(studyId: number, itemId: string): Observable<any> {
    return this.http.get('/api/InternetReview/DownloadScrapedScreenshot/' + studyId + '/' + itemId, { responseType: 'blob' });
  }
}
